import { useSplitClient } from "@splitsoftware/splitio-react";
const useIsConciergeEnabled = (options) => {
  var _a;
  const splitIO = useSplitClient();
  const conciergeTreatment = (_a = splitIO.client) == null ? void 0 : _a.getTreatment("brandclub_concierge", {
    email: (options == null ? void 0 : options.email) || ""
  });
  const showWidget = window.location.hostname.includes("brandclub");
  const showConversationStarters = window.location.hostname.includes("brandclub");
  const showInHeader = window.location.hostname.includes("brandclub") && conciergeTreatment !== "off";
  return {
    showWidget,
    showConversationStarters,
    showInHeader
  };
};
export {
  useIsConciergeEnabled
};
//# sourceMappingURL=useIsConciergeEnabled.js.map
